export const BULK_ORDER_MAX_ROWS = 300;
export const BULK_ORDER_MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB

export const BULK_ORDER_REQUIRED_COLUMNS = [
  "external_order_id",
  "customer_id",
  "distributor_id",
  "retailer_id",
  "dispatch_type",
  "patient_name",
  "eye",
  "lnam",
  "coating",
  "corridor",
  "fitting",
  "sph",
  "cyl",
  "axis",
  "add",
  "dia",
  "ellh",
  "special_instructions",
  "order_received_by",
  "reference_id",
  "product_group_id",
];

/** Columns that must have a non-empty value on every data row */
export const BULK_ORDER_MANDATORY_ROW_FIELDS = ["product_group_id"];

export const BULK_ORDER_SAMPLE_PATH = "/assets/sample.csv";

export const BULK_ORDER_SAMPLE_DOWNLOAD_NAME = "sample.csv";
